// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Scrollbar container */
.HQFMQWhSpATwhgjn {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  padding: 5px 5px 0 5px;
  z-index: 10;
}

.XUrnFRDXQo4KVKKg {
  position: relative;
  height: 100%;
  width: 11px;
}

/* Apply these styles to any range input inside our component */
.RJZMVcH7gQILl_a2 {
  position: absolute;
  left: 12px;
  top: 0;
  height: 12px;
  -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
  -webkit-transform-origin: top left;
          transform-origin: top left;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  background-color: transparent;
  padding: 0;
}

/* Thumb styles for WebKit browsers - more specific selector */
input[type='range'].RJZMVcH7gQILl_a2::-webkit-slider-thumb {
  -webkit-appearance: none !important;
  background-color: hsl(var(--neutral));
  opacity: 50%;
  border: none;
  border-radius: 57px;
  cursor: -webkit-grab;
  height: 8px;
  margin-top: -4px;
  width: 32px;
}

input[type='range'].RJZMVcH7gQILl_a2::-webkit-slider-thumb:active,
input[type='range'].RJZMVcH7gQILl_a2::-webkit-slider-thumb:hover {
  background-color: hsl(var(--primary));
  opacity: 60%;
  cursor: -webkit-grabbing;
}

/* Thumb styles for Firefox - more specific selector */
input[type='range'].RJZMVcH7gQILl_a2::-moz-range-thumb {
  background-color: hsl(var(--neutral));
  opacity: 50%;
  border: none;
  border-radius: 57px;
  cursor: -moz-grab;
  height: 12px;
  width: 39px;
}

input[type='range'].RJZMVcH7gQILl_a2::-moz-range-thumb:active,
input[type='range'].RJZMVcH7gQILl_a2::-moz-range-thumb:hover {
  background-color: hsl(var(--primary));
  opacity: 50%;
  cursor: -moz-grabbing;
}

/* Track styles for WebKit browsers - more specific selector */
input[type='range'].RJZMVcH7gQILl_a2::-webkit-slider-runnable-track {
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 5px;
}

/* Track styles for Firefox - more specific selector */
input[type='range'].RJZMVcH7gQILl_a2::-moz-range-track {
  background-color: transparent;
  border: none;
  cursor: pointer;
  height: 2px;
}

/* Ensure focus doesn't show an outline */
.RJZMVcH7gQILl_a2:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./../../ui-next/src/components/Viewport/ImageScrollbar.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EACZ,gCAAwB;UAAxB,wBAAwB;EACxB,kCAA0B;UAA1B,0BAA0B;EAG1B,wBAAgB;KAAhB,qBAAgB;UAAhB,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA,8DAA8D;AAC9D;EACE,mCAAmC;EACnC,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,qCAAqC;EACrC,YAAY;EACZ,wBAAwB;AAC1B;;AAEA,sDAAsD;AACtD;EACE,qCAAqC;EACrC,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,qCAAqC;EACrC,YAAY;EACZ,qBAAqB;AACvB;;AAEA,8DAA8D;AAC9D;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA,sDAAsD;AACtD;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA,yCAAyC;AACzC;EACE,aAAa;AACf","sourcesContent":["/* Scrollbar container */\n.scrollbarContainer {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  padding: 5px 5px 0 5px;\n  z-index: 10;\n}\n\n.scrollbarInner {\n  position: relative;\n  height: 100%;\n  width: 11px;\n}\n\n/* Apply these styles to any range input inside our component */\n.scrollbarInput {\n  position: absolute;\n  left: 12px;\n  top: 0;\n  height: 12px;\n  transform: rotate(90deg);\n  transform-origin: top left;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-color: transparent;\n  padding: 0;\n}\n\n/* Thumb styles for WebKit browsers - more specific selector */\ninput[type='range'].scrollbarInput::-webkit-slider-thumb {\n  -webkit-appearance: none !important;\n  background-color: hsl(var(--neutral));\n  opacity: 50%;\n  border: none;\n  border-radius: 57px;\n  cursor: -webkit-grab;\n  height: 8px;\n  margin-top: -4px;\n  width: 32px;\n}\n\ninput[type='range'].scrollbarInput::-webkit-slider-thumb:active,\ninput[type='range'].scrollbarInput::-webkit-slider-thumb:hover {\n  background-color: hsl(var(--primary));\n  opacity: 60%;\n  cursor: -webkit-grabbing;\n}\n\n/* Thumb styles for Firefox - more specific selector */\ninput[type='range'].scrollbarInput::-moz-range-thumb {\n  background-color: hsl(var(--neutral));\n  opacity: 50%;\n  border: none;\n  border-radius: 57px;\n  cursor: -moz-grab;\n  height: 12px;\n  width: 39px;\n}\n\ninput[type='range'].scrollbarInput::-moz-range-thumb:active,\ninput[type='range'].scrollbarInput::-moz-range-thumb:hover {\n  background-color: hsl(var(--primary));\n  opacity: 50%;\n  cursor: -moz-grabbing;\n}\n\n/* Track styles for WebKit browsers - more specific selector */\ninput[type='range'].scrollbarInput::-webkit-slider-runnable-track {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  height: 5px;\n}\n\n/* Track styles for Firefox - more specific selector */\ninput[type='range'].scrollbarInput::-moz-range-track {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  height: 2px;\n}\n\n/* Ensure focus doesn't show an outline */\n.scrollbarInput:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scrollbarContainer": `HQFMQWhSpATwhgjn`,
	"scrollbarInner": `XUrnFRDXQo4KVKKg`,
	"scrollbarInput": `RJZMVcH7gQILl_a2`
};
export default ___CSS_LOADER_EXPORT___;
